<template>
  <div class="mb-2">
    <AppFilter :filters="filterConfig" :filter-submitting="filterSubmitting" @filter="handleFilter">
      <template #extra-actions>
        <b-button
          id="custom-columns-btn"
          variant="outline-primary"
          class="d-flex align-items-center"
          @click="$emit('open-columns')"
        >
          <feather-icon icon="ColumnsIcon" size="14" class="mr-50" />
          {{ $t('Columns') }}
        </b-button>
        <b-button
          id="create-new-btn"
          variant="primary"
          class="create-new-btn"
          @click="createProduct"
        >
          <feather-icon icon="PlusIcon" size="15" />
          {{ $t('Create Product') }}
        </b-button>
      </template>
    </AppFilter>
  </div>
</template>

<script>
import AppFilter from '@/components/AppFilter/AppFilter.vue';
import { BButton } from 'bootstrap-vue';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { helper } from '@core/mixins/helper.js';
import { mapGetters } from 'vuex';

export default {
  name: 'ProductListFilter',

  components: {
    AppFilter,
    BButton
  },

  mixins: [helper],

  props: {
    values: {
      type: Object,
      required: true
    },
    filterSubmitting: {
      type: Boolean,
      required: true,
      default: false
    }
  },

  computed: {
    ...mapGetters({
      countries: 'app/countries',
      currencies: 'app/currencies'
    }),

    filterConfig() {
      return [
        {
          id: 'description',
          label: 'Product Name',
          type: 'text',
          placeholder: 'Product Name'
        },
        {
          id: 'gtip',
          label: 'Gtip Code',
          type: 'text',
          placeholder: 'Gtip Code'
        },
        {
          id: 'origin',
          label: 'Origin',
          type: 'select',
          options: this.countryOptions,
          placeholder: 'Make a Choice'
        },
        {
          id: 'currency_code',
          label: 'Currency Code',
          type: 'select',
          options: this.currencyOptions,
          placeholder: 'Make a Choice'
        }
      ];
    },

    countryOptions() {
      return (this.countries || []).map(item => ({
        value: item.iso2,
        label: item.text
      }));
    },

    currencyOptions() {
      return (this.currencies || []).map(item => ({
        value: item.code,
        label: item.text
      }));
    }
  },

  async created() {
    await this.$store.dispatch('app/getCountries');
    await this.$store.dispatch('app/getCurrencies');
  },

  methods: {
    handleFilter(filters) {
      this.$emit('filter', this.getFilteredObject(filters));
    },

    createProduct() {
      this.$router.push('/products/create');
    }
  },

  setup() {
    const { t } = useI18nUtils();
    return { t };
  }
};
</script>
